module.exports = "/images/vendor/flag-icon-css/flags/1x1/tz.svg?d02545a1e6ca8ee2c217c28e7c44dedc";